import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../../../utils/callApi'
import { API_ROUTES } from '../../../../utils/apiRoutes'
import { ActionTypes, TBidsByBidden, TBidsByBiddenChild } from './types'
import { SnackBar } from '../../../../components/ui/SnackBar'

const { addSnackBar } = SnackBar()


function* getBidsByBiddenWorker(action: ReturnType<typeof Actions.GetBidsByBidden.request>) {
  const { callBack, idTender, offset, limit, search, sortBy, sort } = action.payload as Actions.TypeGetBidsByBiddenR
  let success = true
  let data = null
  
  let query = `?Offset=${offset || 0}&Limit=${limit || 20}`
  query += search ? `&Search=${search}` : ''
  query += sortBy ? `&SortBy=${sortBy}` : ''
  query += sort ? `&Sort=${sort}` : ''
  
  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminTenders}/${idTender}/users${query}`,
    })) as TBidsByBidden[]
    if (offset !== 0) {
      yield put(Actions.GetBidsByBidden.success(data))
    } else {
      yield put(Actions.GetBidsByBiddenWith0Offset.success(data))
    }
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetBidsByBidden.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* getBidsByBiddenChildWorker(action: ReturnType<typeof Actions.GetBidsByBiddenChild.request>) {
  const { callBack, idTender, idUser } = action.payload as Actions.TypeGetBidsByBiddenChildR
  let success = true
  let data = null
  
  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminTenders}/${idTender}/users/${idUser}/bids`,
    })) as TBidsByBiddenChild[]
    
    yield put(Actions.GetBidsByBiddenChild.success({ data, idItem: +`${idTender}${idUser}` }))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetBidsByBiddenChild.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
    if (!success) addSnackBar(data?.message || '', success)
  }
}


function* watchRequest() {
  yield takeEvery(ActionTypes.GET_BIDS_BY_BIDDEN_R, getBidsByBiddenWorker)
  yield takeEvery(ActionTypes.GET_BIDS_BY_BIDDEN_CHILD_R, getBidsByBiddenChildWorker)
  
}

export default function* bidsByBiddenSaga() {
  yield all([fork(watchRequest)])
}
